// ?> project links and images //

const blog = [
	{
		Name: "Mastering the Software Development Lifecycle: Navigating Development and Production Environments",
		Description:
			"As a software engineer, you have come across this issue of working in my system but not working on the production.",
		Stack: "medium.",
		img: "/img/environment.png",
		url: "https://medium.com/@chamberezigbo/mastering-the-software-development-lifecycle-navigating-development-and-production-environments-738b6556af65",
	},
	{
		Name: "Server-Side Rendering vs. Client-Side Rendering: Exploring Next.js’ Role in Web Development",
		Description:
			"Server-Side Rendering vs. Client-Side Rendering: Exploring Next.js’ Role in Web",
		Stack: "medium.",
		img: "/img/serverside.PNG",
		url: "https://medium.com/@chamberezigbo/server-side-rendering-vs-client-side-rendering-exploring-next-js-role-in-web-development-714a8162ba03?source=friends_link&sk=89adbedcbe549b8c6192dbacaef04da3",
	},
	{
		Name: "Connecting Your Express App to cPanel MySQL: A Step-by-Step Guide",
		Description:
			"Connecting Your Express App to cPanel MySQL: A Step-by-Step Guide",
		Stack: "medium.",
		img: "/img/express.PNG",
		url: "https://medium.com/@chamberezigbo/connecting-your-express-app-to-cpanel-mysql-a-step-by-step-guide-ee209e08f77a?source=friends_link&sk=7474d4a82f0c0eaa85409578efae0dba",
	},
	{
		Name: "PHP RoadMap",
		Description:
			"The PHP Roadmap is my path to mastering PHP development. From foundational syntax to advanced web frameworks and security, I'm dedicated to honing my skills as a software engineer based in Nigeria.",
		Stack: "Hashnode",
		img: "/img/php.PNG",
		url: "https://chamber.hashnode.dev/php-roadmap",
	},
	{
		Name: "What You Should Know About JavaScript",
		Description:
			"Javascript is a programming language that works on a v8 engine. this engine helps your browser to understand and interact with javascript. Note if you are using an external file for javascript it must be saved with a file extension of js",
		Stack: "Hashnode",
		img: "/img/javascript.PNG",
		url: "https://chamber.hashnode.dev/what-you-should-know-about-javascript",
	},
];

export default blog;
